import { Environment } from './environment.interface';
export { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  brands: {
    enelx: {
      baseUrl: '/',
    },
  },
  defaults: {
    brand: 'enelx',
    locale: 'en-us',
  },
  dataprovider_id: {
    ENEL_IOT_FLEXIBILITY : 'd4b783a4-5ce6-4358-a1eb-2d064105f790',
  },
};
